export const routes = {
  /*[ USER ROUTES ]*/
  getUserInformation: 'user/customer/userName',

  /*[ LOAN ROUTES ]*/
  getDetailsCredit: 'loan/loan/getDetailsCredit/',
  internalBuroStartWorkFlow: 'loan/loan-application/internalBuro/ ',
  postCallProccessPse: 'loan/loan-application/paymentStart',
  credit: 'private/credit',

  /*[ LOANAPPLICATION ROUTES ]*/
  DataValidationService: 'loanapplication/data-confirmation/execute',
  getLeftDaysToNewLoanApplication: 'loanapplication/loan-application/days-to-new/',
  getMutualContractFile: 'loanapplication/get-contract-template/execute/',
  productValidationsStartWorkFlow: 'loanapplication/initial-product/execute',
  signatureFlow: 'loanapplication/v1/prepare-signature/execute',
  checkProcess: 'loanapplication/loan-application/check-process',

  sanitizeFields: 'loanapplication/data-confirmation/verify-fields',

  /*[ DECISION MODEL ROUTES ]*/
  initialValidations: 'decision/identity-validations/execute/v1/initial/validation',
  decisionModelValidations: 'decision/decision-model/execute',
  finalValidations: 'decision/identity-validations/execute/v1/final/validation',
  counterOfferProcess: 'decision/counteroffer/process/{accept}',
  counterOfferResponse: 'decision/counteroffer/get_counteroffer_response',
  confirmDateOfIssue: 'decision/decision-model/execute/document-issue',
  getAllBanks: 'decision/dispersion/get-all-banks',

  /*[ SYSTEMCONFIG ROUTES ]*/
  getConfigurationSystem: 'systemconfig/search/group/',
  getDataTermsFinalDecision: 'systemconfig/search/key/P-39/product/2',
  getDataTerms: 'systemconfig/search/key/conditionTermsDataValidation/product/2',
  getFromSystemConfiguration: 'systemconfig/search/group/',

  /*[ ONBOARDING ROUTES ]*/
  createAccountUrl: 'onboarding/account/create',
  createAditionalDataInCustomerUrl: 'onboarding/customer/additional-info',
  getList: 'onboarding/list/',
  getCities: 'onboarding/list/locations/find',
  emailVerification: 'onboarding/account/exists',
  saveTermsConditions: 'onboarding/customer/accept-terms',

  /*[ORIGINATION ROUTES]*/
  originationParametersByKey: 'origination/system/onr-parameter/{key}',
  originationParametersByKeyAndGroup: 'origination/system/onr-parameter/{key}/{group}',

  /*[ OTHERS ]*/
  sendPetition: 'petition',

  /*[BACK-DEBT]*/
  verifyLoanNovation: 'verify/loan/novation',
};
